import { computed, type ComputedRef } from 'vue'
import {
  createGetItemIdFromKey,
  defaultGetItemId,
  type OptionLabelKey,
} from './gpx-select-option-utils'

export type GpxSelectFieldKeysProps = {
  valueKey?: string | null
  labelKey?: OptionLabelKey
  optionLabel?: OptionLabelKey
  optionValue?: string | null
  dataKey?: string | null
  getItemId?: ((item: unknown) => string | number) | null
}

export type GpxSelectFieldKeys = {
  effectiveValueKey: string | null
  effectiveLabelKey: OptionLabelKey
  effectiveDataKey: string | null
  effectiveGetItemId: (item: unknown) => string | number
  primeOptionLabel: OptionLabelKey
  primeOptionValue: string | null
}

export function useGpxSelectFieldKeys(
  props: GpxSelectFieldKeysProps,
  attrs: Record<string, unknown>,
): ComputedRef<GpxSelectFieldKeys> {
  return computed(() => {
    const valueKey =
      props.valueKey ??
      props.optionValue ??
      (attrs.optionValue as string | undefined) ??
      (attrs['option-value'] as string | undefined) ??
      null

    const labelKey: OptionLabelKey =
      props.labelKey ??
      props.optionLabel ??
      (attrs.optionLabel as OptionLabelKey) ??
      (attrs['option-label'] as OptionLabelKey) ??
      null

    const effectiveDataKey =
      props.dataKey ??
      (attrs.dataKey as string | undefined) ??
      (attrs['data-key'] as string | undefined) ??
      valueKey

    const effectiveGetItemId =
      props.getItemId ??
      (valueKey ? createGetItemIdFromKey(valueKey) : defaultGetItemId)

    return {
      effectiveValueKey: valueKey,
      effectiveLabelKey: labelKey,
      effectiveDataKey,
      effectiveGetItemId,
      primeOptionLabel: labelKey,
      primeOptionValue: valueKey,
    }
  })
}
